import { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import type { QuestionSection } from '../../types/types';

interface SectionEditorModalProps {
  section: QuestionSection;
  onSave: (updatedSection: QuestionSection) => void;
  onClose: () => void;
}

const SectionEditorModal: React.FC<SectionEditorModalProps> = ({
  section,
  onSave,
  onClose,
}) => {
  const [title, setTitle] = useState(section.title);

  const handleSave = () => {
    if (!title.trim()) return;
    onSave({ ...section, title: title.trim() });
    onClose();
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Section</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleSave();
          }}
        >
          <Form.Group controlId="sectionTitle">
            <Form.Label>Section Title</Form.Label>
            <Form.Control
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter section title"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Section
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SectionEditorModal;
